<template>
    <div>
      <base-header class="pb-6" type="">
        <b-row class="align-items-center py-4">
          <b-col lg="12" cols="12">
            <!-- <h6 class="h2 text-white d-inline-block mb-0">{{$route.name}}</h6> -->
            <h6 class="h2 d-inline-block mb-0">{{language_terms[$route.name]}}</h6>
            <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
              <route-breadcrumb/>
            </nav>
          </b-col>

        </b-row>
      </base-header>
      <b-container fluid class="mt--6">
        <div>
            <loading :active="loadingCounter > 0" 
              color= '#007bff'
              :width= '128'
              :height= '128'
              loader='dots'
              :can-cancel="true" 
              :is-full-page="true">
            </loading>
        </div>
        <b-row>
            <b-col lg="12">
                <div class="card-wrapper">
                    <b-card>
                        <div slot="header" class="mb-0">
                            <b-row>
                                <b-col cols="8">
                                    <h3>{{language_terms['QUICK_SEARCH']}}</h3>
                                </b-col>
                            </b-row>
                        </div>
                        <b-row>
                            <b-col cols="3">
                                <base-input :label="language_terms['DATE_FROM']">
                                    <flat-picker slot-scope="{focus, blur}"
                                                @on-open="focus"
                                                @on-close="blur"
                                                style="background-color: white;"
                                                class="form-control datepicker"
                                                v-model="filter.date_from">
                                    </flat-picker>
                                </base-input>
                            </b-col>
                            <b-col cols="3">
                                <base-input :label="language_terms['DATE_TO']">
                                    <flat-picker slot-scope="{focus, blur}"
                                                @on-open="focus"
                                                @on-close="blur"
                                                style="background-color: white;"
                                                class="form-control datepicker"
                                                v-model="filter.date_to">
                                    </flat-picker>
                                </base-input>
                            </b-col>
                            <b-col cols="3">
                                <label class="form-control-label">{{language_terms['CUSTOMER']}}</label>
                                <customerLookup v-bind:url="apiCustomerLookup" v-on:selected="selectCustomer($event)" :lookupId="filter.contact_code"/>
                            </b-col>
                            <b-col cols="2">
                                <base-input :label="language_terms['DOCUMENT_NUMBER']" v-model="filter.so_code"></base-input>
                            </b-col>
                            <b-col cols="1" class="mt-4">
                                <base-button type="primary" @click="clickOnSearch" class="mt-2"><i class="fa fa-search"></i></base-button>
                            </b-col>
                        </b-row>
                    </b-card>
                    <b-card v-if="document.items.length > 0">
                        <div slot="header" class="mb-0">
                            <b-row>
                                <b-col cols="12">
                                    <span style="font-weight: bold">{{ language_terms['TRADE_ITEMS'] }} </span>
                                </b-col>
                            </b-row>
                        </div>
                        <b-row> 
                            <b-col cols="12">
                                <b-card v-for="(item, j) in document.items" :key="j">
                                    <b-row>
                                        <b-col md="1">
                                            <base-input :label="language_terms['DOCUMENT']" v-model="item.so_code" disabled></base-input>
                                        </b-col>
                                        <b-col md="3">
                                            <base-input :label="language_terms['CUSTOMER']" v-model="item.contact_name" disabled></base-input>
                                        </b-col>
                                        <b-col md="1">
                                            <base-input :label="language_terms['SNO']" v-model="item.sno" disabled></base-input>
                                        </b-col>
                                        <b-col md="5">
                                            <base-input :label="language_terms['TRADE_ITEM_DESP']" v-model="item.product_name" disabled></base-input>
                                        </b-col>
                                        <b-col md="1">
                                            <base-input :label="language_terms['SO_QTY']" v-model="item.so_qty" disabled></base-input>
                                        </b-col>
                                        <b-col md="1">
                                            <base-input label="Avail Qty" v-model="item.available_qty" disabled></base-input>
                                        </b-col>
                                        <b-col md="6">
                                            <label class="form-control-label">{{language_terms['VENDOR']}}</label>
                                            <multiselect
                                            open-direction="bottom"
                                            :tag-placeholder="language_terms['ADD_NEW_TAG']"
                                            :placeholder="language_terms['VENDOR']"
                                            label="vendor_name"
                                            track-by="sno"
                                            :options="item.vendors"
                                            text-field="vendor_name"
                                            :multiple="false"
                                            v-model="item.vendor"
                                            :taggable="false">
                                            </multiselect>
                                        </b-col>
                                        <b-col md="6">
                                            <base-input :label="language_terms['VENDOR_DESCRIPTION']" v-model="item.product_name" type="text" ></base-input>
                                        </b-col>                                        
                                        <b-col md="3">
                                            <base-input label="Purchase Price" v-model="item.unit_price" type="number" ></base-input>
                                        </b-col>
                                        <b-col md="3">
                                            <base-input label="Sale Price" v-model="item.sale_unit_price" type="number" disabled></base-input>
                                        </b-col>
                                        <b-col md="2">
                                            <base-input :label="language_terms['QTY']" v-model="item.qty" type="number" ></base-input>
                                        </b-col>
                                        <b-col md="4">
                                            <base-input :label="language_terms['LAST_PURCHASE_DATE']" v-model="item.last_purchase_date" type="date" disabled></base-input>
                                        </b-col>
                                    </b-row>
                                </b-card>
                                <!-- <div>
                                    <table class="table table-striped table-responsive">
                                        <thead head-variant="light">
                                            <th>{{language_terms['SALE_ORDER']}}</th>
                                            <th>{{language_terms['TRADE_ITEM_DESP']}}</th>
                                            <th>{{language_terms['SO_QTY']}}</th>
                                            <th>{{language_terms['AVAILABLE_QTY']}}</th>
                                            <th>{{language_terms['BALANCE']}}</th>
                                            <th>{{language_terms['VENDOR']}}</th>
                                            <th>{{language_terms['COST_PRICE']}}</th>
                                            <th>{{language_terms['QTY']}}</th>
                                            <th>{{language_terms['LAST_PURCHASE_DATE']}}</th>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, j) in document.items" :key="j">
                                                <td>{{item.so_code}}
                                                    <br/>{{item.contact_name}}
                                                </td>
                                                <td>{{item.sno}}. {{item.product_name}}</td>
                                                <td>{{item.so_qty}}</td>
                                                <td>{{item.available_qty}}</td>
                                                <td>{{item.balance_qty}}</td>
                                                <td style="min-width:280px">
                                                    <multiselect
                                                        open-direction="bottom"
                                                        :tag-placeholder="language_terms['ADD_NEW_TAG']"
                                                        :placeholder="language_terms['VENDOR']"
                                                        label="vendor_name"
                                                        track-by="sno"
                                                        :options="item.vendors"
                                                        text-field="vendor_name"
                                                        :multiple="false"
                                                        v-model="item.vendor"
                                                        :taggable="false">
                                                    </multiselect>
                                                </td>
                                                <td style="min-width:180px"><base-input v-model="item.unit_price" type="number" ></base-input>
                                             
                                                </td>
                                                <td style="min-width:180px"><base-input v-model="item.qty" type="number" ></base-input></td>
                                                <td>{{item.last_purchase_date}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div> -->
                            </b-col>
                        </b-row>
                    </b-card>
                </div>
            </b-col>
        </b-row>
      </b-container>
      <div class="floating-bar" v-if="document.items.length > 0">
          <div class="floating-bar-container" align="center">
              <b-button-group>
                <b-button class="transparent-btn" @click = "generatePo">
                    <i class="fas fa-file mr-2 text-success"></i>{{language_terms['GENERATE_PO']}}
                </b-button>
                <b-button class="transparent-btn">
                    <i class="fas fa-times  mr-2 text-danger"></i>{{language_terms['CANCEL']}}
                </b-button>
              </b-button-group>
          </div>
      </div>
        <b-modal v-model="generate_po_modal" :title="language_terms['GENERATED_POS']" centered  no-close-on-backdrop hide-header-close>
                <b-row>
                    <b-col cols="12">
                        <b-table-simple hover striped>
                            <b-thead head-variant="light">
                                <b-th>{{language_terms['SNO']}}</b-th>
                                <b-th>{{language_terms['INVOICE']}}</b-th>
                                <b-th></b-th>
                            </b-thead>
                            <b-tbody>
                                <tr v-for="(po, i) in gerenate_po_codes" :key="i">
                                    <td>{{i + 1}}</td>
                                    <td>{{po.code}}</td>
                                    <td><a href="javascript:void(0)" @click="viewPO(po.code)">{{language_terms['VIEW']}}</a></td>
                                </tr>
                            </b-tbody>
                        </b-table-simple>
                    </b-col>
                </b-row>
                <template #modal-footer="{ ok, cancel }">
                    <!-- Emulate built in modal footer ok and cancel button actions -->
                    <b-button variant="primary" @click="routeToMain">
                        {{language_terms['CLOSE']}}
                    </b-button>
              </template>
        </b-modal>
    </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
import { mapState } from "vuex";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';  
import { Select, Option } from 'element-ui'
import customerLookup from "@/components/Autocomplete.vue";
import axios from "axios";
import { apiRoutes } from "../../apiRoutes";
import { authHeader } from "../../global";
import moment from "moment";

export default 
{
    async mounted(){
        let date = moment().format("YYYY-MM-DD")
        this.filter.date_from = date;
        this.filter.date_to = date;
            
    },
    components:{
        Loading,
        [Select.name]: Select,
        [Option.name]: Option,
        flatPicker,
        customerLookup
    },
    computed:{
      ...mapState({
        language_terms: state => state.languages.language_terms,
        selected_lang: state => state.languages.selected_langauge,
        so_trade_items: state => state.sales.so_trade_items_for_purchase,
        gerenate_po_codes: state => state.purchase.gerenate_po_codes
      }),
    },
    data(){
        return{
            apiCustomerLookup:apiRoutes["CUSTOMER_LOOKUP"],
            loadingCounter:false,
            generate_po_modal:false,
            filter:{
                date_from:"",
                date_to:"",
                contact_id:"",
                contact_code:"",
                contact_name:"",
                so_code:""
            },
            document:
            {
                items:[]
            }
        }
    },
    methods:{
        viewPO(code)
        {
            let url = "/purchase/purchase-order/" + encodeURIComponent(code)
            window.open(url, '_blank')
            // this.$router.push("/purchase/purchase-order/" + code)
        },
        async generatePo()
        {
            await this.$store.dispatch("purchase/generatePurchaseForTradeItems", this.document)
            
            if(this.gerenate_po_codes.length > 0)
            {
                this.generate_po_modal = true
            }
        },
        routeToMain()
        {
            this.$router.push("/purchase/purchase-orders/")
        },
        async clickOnSearch()
        {
            this.loadingCounter++;
            await this.$store.dispatch("sales/fetchTradeSoItemsForPO", this.filter)
            this.document.items = this.so_trade_items

            for (let x=0; x < this.document.items.length; x++)
            {
                this.document.items[x].vendor = this.document.items[x].vendors[0]  
            }
            this.loadingCounter--;
        },
        selectCustomer(obj)
        {
            let contact_code = ''
            let contact_id = ''
            let contact_name = ''

            if(obj)
            {
                contact_code = obj.code
                contact_name = obj.name
                contact_id = obj.id

                this.filter.contact_id = contact_id
                this.filter.contact_code = contact_code
                this.filter.contact_name = contact_name
            }
        }
    }
}
</script>
